import React, { forwardRef, useImperativeHandle } from "react";
import { Card } from "@mui/material";
import PropTypes from "prop-types";
import { formCardStyle } from '../../TransitionStyles';

const AccountsReviewable = forwardRef(({ setFormData }, ref) => {

  const submitForm = async (allData) => {
   console.log("accountReviewable")
  };

  useImperativeHandle(ref, () => ({submitForm}));

  return <Card sx={formCardStyle} /> 
})

export default AccountsReviewable;

AccountsReviewable.propTypes = {
  setFormData: PropTypes.func
}